export function removeLocaleFromUrl (url: string): string {
  return url.replace(/\/en(\/|$|#|\?)/g, '$1');
}
